import { get } from "app/utils/axios/kheti";
import { AdvisoryData } from "../models/advistory";
import { getCookieValue } from "app/farmer360/utils/helper";
const ids = "a463f265-4841-4075-bad7-e16d7719f716";
const fetchAdvisory = async (id: string): Promise<AdvisoryData> => {
  const userAuthId = getCookieValue("userAuthId");
  return await get(`advisory/v1/subscription/${id}/advisory-results/`, {
    ...(userAuthId ? { farmer: userAuthId } : {}),
  });
};

export default fetchAdvisory;
